module.exports = new __parcel__URL__("back2.7df4d33c.svg").toString();